module.exports = __webpack_public_path__ + "static/media/userprofileIcon.3c517b11.svg";